/* eslint-disable react/display-name */
import * as React from 'react';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FilledInput from '@material-ui/core/FilledInput';
import MenuItem from '@material-ui/core/MenuItem';
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import { ReactComponent as CaretDownIcon } from '../../../../assets/svg/icons/caret-down.svg';

const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        errorMessage: {
            color: theme.palette.error.main,
            display: 'block',
            textAlign: 'right',
            fontSize: theme.typography.pxToRem(12)
        }
    });
});

const selectInput = function SelectInput({
    className,
    defaultValue,
    controlledValue,
    errorObject,
    isDisabled,
    isFullWidth = true,
    isRequired,
    label,
    name,
    onChange,
    options,
    autocomplete
}: SelectInputProps) {
    const classes = useStyles(0);
    const defaultSelection = (defaultValue !== undefined ? defaultValue : '');
    const [value, setValue] = React.useState<number | string>(defaultSelection);
    const labelIdValue = `combo-label-${name}`;

    function handleChange(event: React.ChangeEvent<{ name?: string | undefined; value: unknown }>) {
        const update: string = event.target.value as string;
        setValue(update);
        onChange(name, update);
    }

    return (
        <FormControl
            className={className}
            disabled={isDisabled}
            error={errorObject !== undefined}
            fullWidth={isFullWidth}
            required={isRequired}
            variant="filled"
        >
            <InputLabel id={labelIdValue}>{label}</InputLabel>
            <Select
                labelId={labelIdValue}
                IconComponent={CaretDownIcon}
                input={
                    <FilledInput
                        name={name}
                        id={name}
                        inputProps={{
                            'data-testid': name
                        }}
                        autoComplete={autocomplete}
                    />
                }
                SelectDisplayProps={{
                    role: 'combobox',
                    'aria-required': isRequired,
                    'aria-expanded': false,
                }}
                onChange={handleChange}
                value={controlledValue || value}
                autoComplete={autocomplete}
            >
                {options.map((item: StringNumberIDObject) => (
                    <MenuItem key={item.id} value={item.id} disabled={item.disabled}>
                        {item.text}
                    </MenuItem>
                ))}
            </Select>
            {errorObject && <span className={classes.errorMessage}>{errorObject.message}</span>}
        </FormControl>
    );
};

export default React.memo(selectInput);
